export interface UiTemplate { width: number; height: number; pixels: number[]; probe: number[][] }
const gray = (f: ImageData, x: number, y: number) => {
  const i = (Math.round(y) * f.width + Math.round(x)) * 4
  return (f.data[i]! + 2 * f.data[i + 1]! + f.data[i + 2]!) / 4
}
export function templateError(f: ImageData, t: UiTemplate, x: number, y: number, sx: number, sy = sx, quick = false): number {
  if (x < 0 || y < 0 || x + t.width * sx > f.width || y + t.height * sy > f.height) return 255
  let total = 0, count = 0
  for (const p of t.probe) {
    total += Math.abs(gray(f, x + (p[0]! + .5) * sx - .5, y + (p[1]! + .5) * sy - .5) - p[2]!)
    if (++count >= 6 && total / count > 70) return 255
  }
  if (quick || total / count > 55) return total / count
  total = 0; count = 0
  for (let yy = 0; yy < t.height; yy++) for (let xx = 0; xx < t.width; xx++) {
    total += Math.abs(gray(f, x + (xx + .5) * sx - .5, y + (yy + .5) * sy - .5) - t.pixels[yy * t.width + xx]!); count++
  }
  return total / count
}
export function refinedTemplateError(f: ImageData, t: UiTemplate, x: number, y: number, sx: number, sy = sx): number {
  let best = 255
  for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) best = Math.min(best, templateError(f, t, x + dx, y + dy, sx, sy))
  return best
}
